import { render, staticRenderFns } from "./WebWidgetConnectModal.vue?vue&type=template&id=09d5fdde&"
import script from "./WebWidgetConnectModal.vue?vue&type=script&lang=js&"
export * from "./WebWidgetConnectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d5fdde')) {
      api.createRecord('09d5fdde', component.options)
    } else {
      api.reload('09d5fdde', component.options)
    }
    module.hot.accept("./WebWidgetConnectModal.vue?vue&type=template&id=09d5fdde&", function () {
      api.rerender('09d5fdde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/channel/WebWidgetConnectModal.vue"
export default component.exports